import { render, staticRenderFns } from "./PlayerControlsButtonNext.vue?vue&type=template&id=59415aa7&"
import script from "./PlayerControlsButtonNext.vue?vue&type=script&lang=js&"
export * from "./PlayerControlsButtonNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports